Object.defineProperty(exports, '__esModule', {
  value: true,
});

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    const string = String(dirtyString);
    const options = dirtyOptions || {};
    const { width } = options;
    const matchPattern = (width && args.matchPatterns[width])
    || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    const matchedString = matchResult[0];
    const parsePatterns = (width && args.parsePatterns[width])
    || args.parsePatterns[args.defaultParseWidth];
    let value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = parsePatterns.findIndex(pattern => pattern.test(string));
    } else {
      value = findKey(parsePatterns, pattern => pattern.test(string));
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value,
      rest: string.slice(matchedString.length),
    };
  };
}

exports.default = buildMatchFn;
module.exports = exports.default;
